var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container column"},[_c('p',{staticClass:"row"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('button',{staticClass:"row",attrs:{"id":"go"},on:{"click":_vm.onclick}},[_vm._v("Dismiss")])])}
var staticRenderFns = []

export { render, staticRenderFns }